// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n8PNURkZppT_5AiNIkKT{display:flex;align-items:center;justify-content:center;padding:5px}`, "",{"version":3,"sources":["webpack://./node_modules/aphrodite.react/Components/Loading/Loading.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,WAAA","sourcesContent":[".loading{display:flex;align-items:center;justify-content:center;padding:5px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `n8PNURkZppT_5AiNIkKT`
};
export default ___CSS_LOADER_EXPORT___;
